import React from "react";
import images from "../../../images";
import NotificationBadge from "../../../components/common/NotificationBadge/NotificationBadge";

const ProfileChevron = ({
  title,
  onClick,
  isShowNotificationBadge = false,
  unreadCount = 0,
}) => {
  return (
    <div
      onClick={onClick}
      className="flex felx-row items-center justify-between min-h-[70px]  w-full text-sm font-medium tracking-tight text-[#333333] rounded-none border-b border-[#E9E6E4] border-solid cursor-pointer"
    >
      <span className="text-xl text-[#333] font-medium flex items-center gap-2">
        {title}
        {isShowNotificationBadge && unreadCount > 0 && (
          <NotificationBadge count={unreadCount} />
        )}
      </span>
      <img src={images.ChevronRightIcon} alt="" className="w-2" />
    </div>
  );
};

export default ProfileChevron;
